module.exports = __webpack_public_path__ + "img/美国站.8b16e1b0.png";